module.exports = __webpack_public_path__ + "img/Node.29bf9c21.png";